function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useTheme } from './ThemeContext';
const styles = require('./FormCheck-styles.module.scss');
const FormCheckInput = React.forwardRef(({
  theme: propsTheme,
  className,
  ...props
}, ref) => {
  const theme = useTheme(propsTheme);
  return React.createElement(React.Fragment, null, React.createElement("input", _extends({
    ref: ref
  }, props, {
    className: styles.input
  })), React.createElement("div", {
    className: classNames(className, styles.check, styles[theme])
  }));
});
FormCheckInput.displayName = 'FormCheckInput';
const propTypes = {
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  theme: PropTypes.oneOf(['dark', 'light']),
  title: PropTypes.string.isRequired,
  inline: PropTypes.bool.isRequired,
  className: PropTypes.string,
  children: PropTypes.node
};
const defaultProps = {
  type: 'checkbox',
  title: '',
  inline: false
};
const FormCheck = React.forwardRef(({
  theme: propsTheme,
  title,
  inline,
  className,
  children,
  ...props
}, ref) => {
  // Explicitly not passing in propsTheme here for light-dark-bg logic below.
  const themeContext = useTheme();
  return React.createElement("label", {
    title: title,
    className: classNames(className, styles.label, themeContext === 'dark' && propsTheme === 'light' ? styles.lightDarkBg : styles[propsTheme || themeContext], inline && styles.inline)
  }, React.createElement(FormCheckInput, _extends({
    ref: ref
  }, props)), React.createElement("span", null, children));
});
FormCheck.displayName = 'FormCheck';
FormCheck.propTypes = propTypes;
FormCheck.defaultProps = defaultProps;
FormCheck.Input = FormCheckInput;
export default FormCheck;